<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 class="login">
            <v-card class="elevation-12">
              <v-form class="text-xs-center" @submit.prevent="login">
                <v-toolbar dark color="primary">
                  <v-toolbar-title>Acceso a Sopheo</v-toolbar-title>
                  <v-spacer />
                </v-toolbar>
                <v-card-text>
                  <v-text-field v-model="user.username" prepend-icon="person" name="login" label="Login" type="text" autofocus />
                  <v-text-field v-model="user.password" prepend-icon="lock" name="password" label="Password" type="password" />

                  <!--<v-radio-group v-model="user.type" :mandatory="false" row>
                    <v-radio :value="1" label="Técnico" />
                    <v-radio :value="2" label="Cliente" class="ml-2" />
                  </v-radio-group>-->
                </v-card-text>
                <v-card-actions class="layout row justify-center pb-3">
                  <v-btn color="primary" type="submit">
                    Login
                  </v-btn>
                </v-card-actions>
              </v-form>
              <inner-loading :visible="loading" />
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import InnerLoading from '@/components/InnerLoading'

export default {
  name: 'Login',
  components: { InnerLoading },
  data () {
    return {
      drawer: null,
      user: {
        username: '',
        password: ''
      },
      loading: false
    }
  },
  metaInfo: {
    title: 'Acceso a Sopheo'
  },
  methods: {
    login: function () {
      this.loading = true
      this.$store.dispatch('AUTH_REQUEST', this.user).then(() => {
      }).catch(() => {
        this.loading = false
      })
    }

  }
}

</script>
           